import axios from 'axios';
import { PowerBIReport } from 'views/power-bi-reports/types/power-bi-report.type';

// GET
// /ewosapi/v1/powerbi/company/{globalCompanyId}/reports
export const getPowerBIReports = async (globalCompanyId: string): Promise<PowerBIReport[]> => {
  const res = await axios.get<PowerBIReport[]>(`/ewosapi/v1/powerbi/company/${globalCompanyId}/reports`);
  return res.data;
};
